import React from "react";
import OnboardingStepper from "./OnboardingStepper";

function OnboardingLayout({ showStepper, currentStep, wide, centered, children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div
        className={`flex-1 flex flex-col items-center px-4 sm:px-6 py-8 sm:py-12 md:py-16 ${
          centered ? "justify-center" : ""
        }`}
      >
        <div
          className={`w-full flex flex-col ${wide ? "max-w-2xl" : "max-w-xl"} ${
            centered ? "" : "flex-1"
          }`}
        >
          {showStepper && (
            <div className="mb-8 sm:mb-12 flex justify-center">
              <OnboardingStepper currentStep={currentStep} />
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

export default OnboardingLayout;
